var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import CatalogMemberReferenceTraits from "./CatalogMemberReferenceTraits";
import MagdaDistributionFormatTraits from "./MagdaDistributionFormatTraits";
import mixTraits from "../mixTraits";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import { traitClass } from "../Trait";
let MagdaReferenceTraits = (_dec = traitClass({
  description: "Creates one catalog item from url that points to a magda record.\n\n  <strong>Note:</strong> \n  <li>The url points to a magda server.</li>\n  <li>A magda record identified by <code>recordId</code> must be mappable.</li>",
  example: {
    type: "magda",
    url: "https://data.gov.au",
    name: "Magda example",
    recordId: "dist-sa-97d6773f-6ce8-4b0b-a2a1-c2687448c672",
    id: "some unique id"
  }
}), _dec2 = primitiveTrait({
  name: "Record ID",
  description: "The ID of the Magda record referred to by this reference.",
  type: "string"
}), _dec3 = anyTrait({
  name: "Magda Record Data",
  description: "The available representation of the Magda record as returned by " + "the Magda registry API. This representation may not include all " + "aspects and it may not be dereferenced."
}), _dec4 = anyTrait({
  name: "Override",
  description: "The properties to apply to the dereferenced item, overriding properties that " + "come from Magda itself."
}), _dec5 = objectArrayTrait({
  name: "Distribution Formats",
  description: "The supported distribution formats and their mapping to Terria types. " + "These are listed in order of preference.",
  type: MagdaDistributionFormatTraits,
  idProperty: "id"
}), _dec6 = anyTrait({
  name: "AddOrOverrideAspects",
  description: "The properties to apply to the dereferenced item, overriding the record aspects"
}), _dec(_class = (_class2 = class MagdaReferenceTraits extends mixTraits(CatalogMemberReferenceTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "recordId", _descriptor, this);
    _initializerDefineProperty(this, "magdaRecord", _descriptor2, this);
    _initializerDefineProperty(this, "override", _descriptor3, this);
    _initializerDefineProperty(this, "distributionFormats", _descriptor4, this);
    _initializerDefineProperty(this, "addOrOverrideAspects", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "recordId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "magdaRecord", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "override", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "distributionFormats", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "addOrOverrideAspects", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { MagdaReferenceTraits as default };